// extracted by mini-css-extract-plugin
export var subText = "style-module--subText--4baff";